import $ from 'jquery';
import BpmnModeler from 'bpmn-js/lib/Modeler';
import {getBusinessObject} from 'bpmn-js/lib/util/ModelUtil';
import propertiesPanelModule from 'bpmn-js-properties-panel';
import propertiesProviderModule from 'bpmn-js-properties-panel/lib/provider/camunda';
import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda.json';
import BpmnApiHelper from './BpmnApiHelper';
import BpmnFormHelper from './BpmnFormHelper';
//import qaExtension from '../resources/qa.json';
import qaExtension from '../../../assets/bpmn/qa.json';
import {log} from './BpmnDebug';
// import BpmnDeploymentHelper from './BpmnDeploymentHelper'
//import BpmnBlocklyHelper from './BpmnBlocklyHelper';
import customPalette from './custom/index';
import customRendererModule from './custom/index';

import parentContextElement from './custom/parentContext'
import {
    debounce
} from 'min-dash';
//import diagramXML from '../../../assets/bpmn/newDiagram.xml';


var BpmnInit = {
    HIGH_PRIORITY: 1500,
    initialised: false,
    bpmnFormGlobals: {},
    isAPIRegistered: false,
    apiName: ''

};
export default BpmnInit;

BpmnInit.diagramXML = function () {
    var processId = new Date().getTime();
    return '<?xml version="1.0" encoding="UTF-8"?>\n' +
        '<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xsi:schemaLocation="http://www.omg.org/spec/BPMN/20100524/MODEL BPMN20.xsd" id="sample-diagram" targetNamespace="http://bpmn.io/schema/bpmn">\n' +
        '  <bpmn2:process id="Process_' + processId + '" isExecutable="true">\n' +
        '    <bpmn2:startEvent id="StartEvent_1" />\n' +
        '  </bpmn2:process>\n' +
        '  <bpmndi:BPMNDiagram id="BPMNDiagram_1">\n' +
        '    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">\n' +
        '      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">\n' +
        '        <dc:Bounds height="36.0" width="36.0" x="412.0" y="240.0"/>\n' +
        '      </bpmndi:BPMNShape>\n' +
        '    </bpmndi:BPMNPlane>\n' +
        '  </bpmndi:BPMNDiagram>\n' +
        '</bpmn2:definitions>\n';
};

BpmnInit.initFormFields = function () {
    BpmnInit.container = $('#js-drop-zone');
    BpmnInit.canvas = $('#js-canvas');
    BpmnInit.formConfigs = {
        serviceTask: {
            prefix: 'serviceTask',

            fieldEls: {

                apiName: document.getElementById('serviceTask-api-name'),
                varName: document.getElementById('serviceTask-var-name'),
                lastChecked: document.getElementById('serviceTask-last-checked'),
                //taskType: document.getElementById('serviceTask-task-type'),
                topic: document.getElementById('serviceTask-topic')

            },
            values: {
                apiName: '',
                varName: '',
                qualityAssurance: '',
                lastChecked: '',
                taskType: 'Connector',
                topic: ''

            },
            validationLogic: (e) => {
                return e.apiName && e.varName;
            },
            validationMessage: 'A name and api'
        },
        sequenceFlow: {
            prefix: 'sequenceFlow',
            fieldEls: {
                condition: document.getElementById('sequenceFlow-condition'),
                select: document.getElementById('sequenceFlow-select'),
                conditionEnd: document.getElementById('sequenceFlow-conditionEnd')
            },
            values: {
                condition: '',
                select: '',
                conditionEnd: ''
            },
            validationLogic: (e) => {
                return true;
            },
            validationMessage: ''

        },
        boundaryEvent: {
            prefix: 'boundaryEvent',
            fieldEls: {
                condition: document.getElementById('boundaryEvent-condition'),
                select: document.getElementById('boundaryEvent-select'),
                conditionEnd: document.getElementById('boundaryEvent-conditionEnd')
            },
            values: {
                condition: '',
                select: '',
                conditionEnd: ''
            },
            validationLogic: (e) => {
                return true;
            },
            validationMessage: ''

        },
        multiInstance: {
            prefix: 'multiInstance',
            fieldEls: {
                collection: document.getElementById('multiInstance-collection'),
                variable: document.getElementById('multiInstance-variable')
            },
            values: {
                collection: '',
                variable: ''
            },
            validationLogic: (e) => {
                return e.collection && e.variable;
            },
            validationMessage: 'A collection and variable must be chosen'
        },
        scripttask: {
            prefix: 'scripttask',
            fieldEls: {
                variable: document.getElementById('scripttask-var-name'),
                editorId: document.getElementById('scripttask-editor')
            },
            values: {
                condition: '',
                collection: [],
                editor: ''
            },
            validationLogic: (e) => {
                return e.collection && e.variable;
            },
            validationMessage: 'A collection and variable must be chosen'
        }
    };
    // check file api availability
    if (!window.FileList || !window.FileReader) {
        window.alert(
            'Looks like you use an older browser that does not support drag and drop. ' +
            'Try using Chrome, Firefox or the Internet Explorer > 10.');
    } else {
        BpmnInit.registerFileDrop(BpmnInit.container, BpmnInit.openDiagram);
    }

    // bootstrap diagram functions

//    $(function () {
//
//        $('#js-create-diagram').click(function (e) {
//            e.stopPropagation();
//            e.preventDefault();
//            BpmnInit.createNewDiagram();
//        });
//        var downloadLink = $('#js-download-diagram');
//        var downloadSvgLink = $('#js-download-svg');
//        $('.buttons a').click(function (e) {
//            if (!$(this).is('.active')) {
//                e.preventDefault();
//                e.stopPropagation();
//            }
//        });
//        function setEncoded(link, name, data) {
//            var encodedData = encodeURIComponent(data);
//            if (data) {
//                link.addClass('active').attr({
//                    'href': 'data:application/bpmn20-xml;charset=UTF-8,' + encodedData,
//                    'download': name
//                });
//            } else {
//                link.removeClass('active');
//            }
//        }
//
//        var exportArtifacts = debounce(async function () {
//
//            try {
//
//                const  svg = BpmnInit.saveSvg();
//                setEncoded(downloadSvgLink, 'diagram.svg', svg);
//            } catch (err) {
//
//                console.error('Error happened saving SVG: ', err);
//                setEncoded(downloadSvgLink, 'diagram.svg', null);
//            }
//
//            try {
//
//                const xml = BpmnInit.saveXml();
//                setEncoded(downloadLink, 'diagram.bpmn', xml);
//            } catch (err) {
//
//                log('Error happened saving XML: ', err);
//                setEncoded(downloadLink, 'diagram.bpmn', null);
//            }
//        }, 500);
//        BpmnInit.bpmnModeler.on('commandStack.changed', exportArtifacts);
//    });
}
BpmnInit.setEncoded = function (link, name, data) {
    var encodedData = encodeURIComponent(data);
    if (!link) {
        return;
    }
    if (data) {
        link.classList.add('active');
        link.setAttribute('href', 'data:application/bpmn20-xml;charset=UTF-8,' + encodedData);
        link.setAttribute('download', name);


    } else {
        link.classList.remove('active');
    }
}
BpmnInit.initDownloadButtonsInitialised = false;
BpmnInit.initDownloadButtons = function () {
    if (BpmnInit.initDownloadButtonsInitialised || !BpmnInit.initialised) {
        return;
    }
    BpmnInit.initDownloadButtonsInitialised = true;
    //return;
    var createNewDiagramEl = document.getElementById('js-create-diagram');
    if (createNewDiagramEl) {
        createNewDiagramEl.addEventListener("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            BpmnInit.createNewDiagram();
        });
    }

    var downloadLink = document.getElementById('js-download-diagram');

    if (downloadLink) {
        downloadLink.addEventListener("click", function (e) {
            if (!$(this).is('.active')) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        const xmlPromise = BpmnInit.saveXml();
        xmlPromise.then(xml => {
            BpmnInit.setEncoded(downloadLink, 'diagram.bpmn', xml);
        });
    }
    var downloadSvgLink = document.getElementById('js-download-svg');
    if (downloadSvgLink) {
        downloadSvgLink.addEventListener("click", function (e) {
            if (!$(this).is('.active')) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        const svgPromise = BpmnInit.saveSvg();
        svgPromise.then(svg => {
            BpmnInit.setEncoded(downloadSvgLink, 'diagram.svg', svg);
        });
    }


    var exportArtifacts = debounce(async function () {

        try {

            const svgPromise = BpmnInit.saveSvg();
            svgPromise.then(svg => {
                BpmnInit.setEncoded(downloadSvgLink, 'diagram.svg', svg);
            });

        } catch (err) {

            log('Error happened saving SVG: ', err);
            //BpmnInit.setEncoded(downloadSvgLink, 'diagram.svg', null);
        }

        try {

            const xmlPromise = BpmnInit.saveXml();
            xmlPromise.then(xml => {
                BpmnInit.setEncoded(downloadLink, 'diagram.bpmn', xml);
            });
        } catch (err) {

            log('Error happened saving XML: ', err);
            // setEncoded(downloadLink, 'diagram.bpmn', null);
        }

    }, 1000);
    BpmnInit.bpmnModeler.on('commandStack.changed', exportArtifacts);
}
BpmnInit.init = function () {
    log("XXXXXXXXXXXXXXXXXXXXXXXXXXXX in bpmn init");
    if (!BpmnInit.initialised) {
        BpmnInit.initFormFields();
        BpmnInit.initialised = true;
    }
    BpmnFormHelper.clearHtmlElement(BpmnInit.canvas);


    BpmnInit.bpmnModeler = new BpmnModeler({
        container: BpmnInit.canvas,
        propertiesPanel: {
            parent: '#js-properties-panel'
        },
        additionalModules: [
            propertiesPanelModule,
            propertiesProviderModule,
            customPalette,
            customRendererModule
        ],
        moddleExtensions: {
            camunda: camundaModdleDescriptor,
            qa: qaExtension
        }
    });
    BpmnInit.bpmnFormGlobals.bpmnModeler = BpmnInit.bpmnModeler;

    //BpmnBlocklyHelper.createWorkspace('blocklyDiv', 'toolbox'); 

    //BpmnBlocklyHelper.createWorkspace (document.getElementById('blocklyDiv'), {xxx:['1','2','3']}) ;

    BpmnInit.container.removeClass('with-diagram');
    // BpmnInit.initDownloadButtons();


    ////// file drag / drop ///////////////////////


    //log("bpmn init creating diagram")
    //BpmnInit.createNewDiagram();
}
BpmnInit.createNewDiagram = function (xml) {
    log("BpmnInit.createNewDiagram", xml);
    if (!xml) {
        xml = BpmnInit.diagramXML();
    }
    log("createNewDiagram", xml);
    if (!BpmnInit.initialised) {
        BpmnInit.init();
    }
    BpmnInit.openDiagram(xml);
}

BpmnInit.openDiagram = async function (xml) {

    try {

        //await bpmnModeler.importXML(xml);
        var bpmnModeler = BpmnInit.bpmnModeler;
        var importResult = await bpmnModeler.importXML(xml);
        var overlays = BpmnInit.bpmnModeler.get('overlays');
        log(BpmnInit.bpmnModeler.get('canvas'));
        log(overlays);
        // overlays.add('StartEvent_1', 'note', {
        //     position: {
        //         bottom: 0,
        //         right: 0
        //     },
        //     html: '<div class="diagram-note">Mixed up the labels?</div>'
        // });
        var eventBus = bpmnModeler.get('eventBus');

        // you may hook into any of the following events
        var events = [
            //                'element.hover',
            //                'element.out',
            //                'element.click',
            //                'element.dblclick',
            //                'element.mousedown',
            //                'element.mouseup',
            //                'element.contextmenu',
            'element.changed'
        ];

        //            events.forEach(function (event) {
        //
        //                eventBus.on(event, function (e) {
        //                    // e.element = the model element
        //                    // e.gfx = the graphical element
        //
        //                    log(event, 'on', e.element.id, e);
        //                });
        //            });


        const moddle = bpmnModeler.get('moddle'),
            modeling = bpmnModeler.get('modeling');
        log("bpmnModeler", bpmnModeler);


        //Commented by sai since we don't need BpmnDeploymentHelper.js file for this release (Suggested by Ant)
        // BpmnDeploymentHelper.init(bpmnModeler);
        let
            businessObject,
            element,
            apiList;


        BpmnApiHelper.getAPIs(element, 'bpmnFactory', 'options', 'translate');


        // open quality assurance if user right clicks on element


        bpmnModeler.on('element.contextmenu', BpmnInit.HIGH_PRIORITY, (event) => {
            BpmnInit.displayMappingPopup(event);

        });


        bpmnModeler.on('element.click', BpmnInit.HIGH_PRIORITY, (event) => {
                // displayMappingPopup(event);
            }
        );

        bpmnModeler.on('element.dblclick', BpmnInit.HIGH_PRIORITY, (event) => {
                BpmnInit.displayMappingPopup(event);

            }
        );


        BpmnFormHelper.setUpForm(BpmnInit.formConfigs.serviceTask, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.ServiceTaskSubmitCallback);
        BpmnFormHelper.setUpForm(BpmnInit.formConfigs.sequenceFlow, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.SequenceFlowSubmitCallback);
        BpmnFormHelper.setUpForm(BpmnInit.formConfigs.boundaryEvent, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.BoundaryEventSubmitCallback);
        BpmnFormHelper.setUpForm(BpmnInit.formConfigs.multiInstance, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.MultiInstanceFlowSubmitCallback);
        BpmnFormHelper.setUpForm(BpmnInit.formConfigs.scripttask, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.ScriptTaskSubmitCallback);


        BpmnFormHelper.ServiceTaskAddAutocomplete(BpmnInit.formConfigs.serviceTask, BpmnInit.bpmnFormGlobals, moddle)
        BpmnFormHelper.setServiceTaskRadioHandler(BpmnInit.formConfigs.serviceTask, BpmnInit.bpmnFormGlobals, moddle);


        BpmnInit.container
            .removeClass('with-error')
            .addClass('with-diagram');
        $('.djs-palette').removeClass('two-column');
    } catch (err) {

        BpmnInit.container
            .removeClass('with-diagram')
            .addClass('with-error');
        BpmnInit.container.find('.error pre').text(err.message);
        log(err);
    }
}

BpmnInit.displayMappingPopup = function (event) {
    var element = event.element;
    // ignore root element
    // if (!element.parent) {
    //     return;
    // }

    var businessObject = getBusinessObject(element);
    log("business object", businessObject);
    log("type", businessObject['$type']);
    let boType = businessObject['$type'];
    log("boType", boType);
    switch (boType) {
        case "bpmn:ServiceTask":
            event.originalEvent.preventDefault();
            event.originalEvent.stopPropagation();
            if (!BpmnInit.isAPIRegistered) {
                log("display mapping popup api not registered");

                BpmnFormHelper.ServiceTaskLoad(BpmnInit.formConfigs.serviceTask, element, businessObject, BpmnInit.bpmnFormGlobals, event);
            } else {
                log("display mapping popup using customer serv ice task load");
                BpmnFormHelper.CustomServiceTaskLoad(BpmnInit.formConfigs.serviceTask, element, businessObject, BpmnInit.bpmnFormGlobals, event, BpmnInit.apiName, BpmnInit.apiName);
                BpmnInit.isAPIRegistered = false;
                BpmnInit.apiName = '';
            }

            break;
        case "bpmn:SubProcess":
            event.originalEvent.preventDefault();
            event.originalEvent.stopPropagation();
            BpmnFormHelper.MultiInstanceFlowLoad(BpmnInit.formConfigs.multiInstance, element, businessObject, BpmnInit.bpmnFormGlobals, event);
            break;
        case "bpmn:ScriptTask":
            event.originalEvent.preventDefault();
            event.originalEvent.stopPropagation();
            BpmnFormHelper.ScriptTaskLoad(BpmnInit.formConfigs.scripttask, element, businessObject, BpmnInit.bpmnFormGlobals, event);
            break;
        case "bpmn:SequenceFlow":
            event.originalEvent.preventDefault();
            event.originalEvent.stopPropagation();
            BpmnFormHelper.SequenceFlowLoad(BpmnInit.formConfigs.sequenceFlow, element, businessObject, BpmnInit.bpmnFormGlobals, event);
            break;
        case "bpmn:BoundaryEvent":
            event.originalEvent.preventDefault();
            event.originalEvent.stopPropagation();
            BpmnFormHelper.BoundaryEventLoad(BpmnInit.formConfigs.boundaryEvent, element, businessObject, BpmnInit.bpmnFormGlobals, event);
            break;

        default:


    }

}
BpmnInit.saveXml = async function () {
    let {xml} = await BpmnInit.bpmnModeler.saveXML({format: true});
    log("saveXml", xml);
    return xml;

}
BpmnInit.saveSvg = async function () {
    let {svg} = await BpmnInit.bpmnModeler.saveSVG({format: true});

    return svg;
}


BpmnInit.registerFileDrop = function (container, callback) {
    if (!container) {
        log("Container not found");
        return;
    }

    function handleFileSelect(e) {
        e.stopPropagation();
        e.preventDefault();
        var files = e.dataTransfer.files;
        // console.log(files);
        var file = files[0];
        var reader = new FileReader();
        if (files && files.length && file) {
            reader.onload = function (e) {

                var xml = e.target.result;
                callback(xml);
            };
            reader.readAsText(file);
        }
    }

    function handleDragOver(e) {
        e.stopPropagation();
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
    }

    container.get(0).addEventListener('dragover', handleDragOver, false);
    container.get(0).addEventListener('drop', handleFileSelect, false);
}

BpmnInit.closeDialog = function (id) {
    document.getElementById(id).open = false;
}

BpmnInit.getAPIs = function(){
    return BpmnApiHelper.apiList;
}

BpmnInit.refreshAPIs = function (apiName) {
    log("refreshing API ", apiName);
    let element;
    BpmnApiHelper.getAPIs(element, 'bpmnFactory', 'options', 'translate');
    var bpmnModeler = BpmnInit.bpmnModeler;
    const moddle = bpmnModeler.get('moddle'),
        modeling = bpmnModeler.get('modeling');
    BpmnFormHelper.setUpForm(BpmnInit.formConfigs.serviceTask, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.ServiceTaskSubmitCallback);
    BpmnFormHelper.setUpForm(BpmnInit.formConfigs.sequenceFlow, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.SequenceFlowSubmitCallback);
    BpmnFormHelper.setUpForm(BpmnInit.formConfigs.boundaryEvent, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.BoundaryEventSubmitCallback);
    BpmnFormHelper.setUpForm(BpmnInit.formConfigs.multiInstance, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.MultiInstanceFlowSubmitCallback);
    BpmnFormHelper.setUpForm(BpmnInit.formConfigs.scripttask, moddle, modeling, BpmnInit.bpmnFormGlobals, BpmnFormHelper.ScriptTaskSubmitCallback);


    BpmnFormHelper.ServiceTaskAddAutocomplete(BpmnInit.formConfigs.serviceTask, BpmnInit.bpmnFormGlobals, moddle);
    const event = {
        "element": {
            "labels": [],
            "children": [],
            "id": "Activity_0wxrdym",
            "width": 100,
            "height": 80,
            "type": "bpmn:ServiceTask",
            "x": 500,
            "y": 218,
            "order": {
                "level": 5
            }
        },
        "gfx": {},
        "originalEvent": {
            "isTrusted": true,
            "delegateTarget": {}
        }
    }
    //BpmnInit.displayMappingPopup(event);
    // const customElement = event.element;
    const customElement = parentContextElement.getParentContextElement();
    customElement.type = 'bpmn:ServiceTask';
    event.element = customElement;
    BpmnInit.isAPIRegistered = true;
    BpmnInit.apiName = apiName;
    var testEvent = new MouseEvent('dblclick', {
        'view': window,
        'bubbles': true,
        'cancelable': true
    });
    var elem = document.querySelector('[data-element-id=' + customElement.id + ']');

    const businessObject = getBusinessObject(customElement);
    // event.originalEvent.preventDefault();
    // event.originalEvent.stopPropagation();
    // BpmnFormHelper.ServiceTaskLoad(BpmnInit.formConfigs.serviceTask, customElement, businessObject, BpmnInit.bpmnFormGlobals, event);

    setTimeout(() => {
        // BpmnFormHelper.CustomServiceTaskLoad(BpmnInit.formConfigs.serviceTask, customElement, businessObject, BpmnInit.bpmnFormGlobals, event, apiName, apiName);
        elem.dispatchEvent(testEvent);
    }, 3000);

}
